import { LoadingOutlined } from "@ant-design/icons";
import { PureComponent, ReactNode } from "react";

export default class LoadingComponent extends PureComponent<{
  color: string;
}> {
  constructor(props: { color: string }) {
    super(props);
  }

  render(): ReactNode {
    const { color } = this.props;
    return (
      <>
        <LoadingOutlined
          style={{
            color: color,
            fontWeight: 500,
          }}
        />
        <span style={{ color: color }} className="font-semibold ml-2">
          {"Loading..."}
        </span>
      </>
    );
  }
}
